import { makeStyles } from "@material-ui/core";

export const TPaquetesStyle = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: "65vh",
  },
  ButtonContent: {
    display: "flex",
    flexFlow: "column wrap",
    justifyContent: "center",
    alignItems: "center",
  },
  section1: {
    margin: theme.spacing(1, 2),
  },
  section2: {
    margin: theme.spacing(1, 2),
  },
}));
